import Keycloak from 'keycloak-js';

const getKeycloakConfigFile = () => {
    const host = window.location.hostname;
    // TEMP: on localhost go through the dev-server proxy (src/setupProxy.js)
    // because iam.beta.appyoukey.it has broken TLS termination.
    // Remove once the beta server is fixed.
    if (host.includes('localhost')) return '/keycloak-local.json';
    if (host.includes('int')) return '/keycloak.json';

    return '/keycloak.json';
};

const kc = new Keycloak(process.env.PUBLIC_URL + getKeycloakConfigFile());

const doLogin = kc.login;

const doLogout = kc.logout;

const getToken = () => kc.token;

const isLoggedIn = () => !!kc.token;

const updateToken = (successCallback) => kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);

const getUsername = () => kc.tokenParsed?.preferred_username;
const getEmail = () => kc.tokenParsed?.email;

const hasRole = (role, client = "web-console") => {
    const resourceAccess = kc?.resourceAccess || {};
    const clientRoles = resourceAccess[client]?.roles || [];
    return clientRoles.includes(role);
};

const getTokenParsed = kc.tokenParsed;

const getNameSurnameInitials = () => `${kc.tokenParsed?.given_name[0]}${kc.tokenParsed?.family_name[0]}`;

const getInstance = kc;

/**
 * Initializes Keycloak instance and calls the provided
 * callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
    kc.init({
        onLoad: 'check-sso',
        flow: 'standard',
        checkLoginIframe: false,
        redirectUri: process.env.PUBLIC_URL,
    })
        .then((authenticated) => {
            if (authenticated) {
                onAuthenticatedCallback();
            } else {
                doLogin();
            }
        })
        .catch((err) => {
            console.error('Keycloak init failed', err);
        });
};

const KeycloakService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    getEmail,
    hasRole,
    getTokenParsed,
    getInstance,
    getNameSurnameInitials,
};

export default KeycloakService;
